var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsterisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.3814 43.3443L44.6526 32.4997L62.3807 21.655C62.6857 21.4681 62.9043 21.1678 62.988 20.8197C63.0716 20.4715 63.0136 20.1045 62.8274 19.7995L57.6179 11.2839C57.2299 10.6483 56.398 10.448 55.7624 10.8366L38.8392 21.1894V1.34943C38.8392 0.604544 38.2347 0 37.4898 0H27.5088C26.7639 0 26.1593 0.604544 26.1593 1.34943V21.1894L9.23546 10.8373C8.59853 10.4486 7.76863 10.6483 7.38 11.2846L2.17052 19.8002C1.9843 20.1052 1.92628 20.4722 2.00994 20.8203C2.09361 21.1685 2.31221 21.4687 2.61718 21.6556L20.346 32.4997L2.61718 43.3443C2.31221 43.5306 2.09361 43.8315 2.00994 44.179C1.92628 44.5278 1.9843 44.8948 2.17052 45.1998L7.38 53.7147C7.76863 54.3503 8.59853 54.5514 9.23546 54.1627L26.1593 43.8099V63.6499C26.1593 64.3948 26.7639 64.9993 27.5088 64.9993H37.4898C38.2347 64.9993 38.8392 64.3948 38.8392 63.6499V43.8106L55.7631 54.1621C56.3987 54.5507 57.2306 54.3503 57.6186 53.7154L62.8281 45.1998C63.0143 44.8948 63.0723 44.5278 62.9886 44.1796C62.9057 43.8308 62.6864 43.5312 62.3814 43.3443Z",
    fill: "#166FD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterisk);
export default __webpack_public_path__ + "static/media/asterisk.8a613793de20a85d0c31c2c4d65081be.svg";
export { ForwardRef as ReactComponent };